import actions from 'redux/actions'
import { constants, mixpanel } from 'common/helpers'


type ProcessVindiciaRefundProps = {
  decision: 'REFUND' | 'RECEIVE'
  type: string
  transactionType: 'PAUSE' | 'SKIP' | 'UNSUBSCRIBE'
  isBillingDay1stEnabled?: boolean
}

const getRefundTimeTypes = (isBillingDay1stEnabled) => ({
  'NEW_SUBSCRIBER': 'before 12 hours',
  'RECURRENT_DAY': isBillingDay1stEnabled ? 'on the 1st' : 'on the 5th',
})

// processing refund after (!) user confirmation
const processVindiciaRefund = async (props: ProcessVindiciaRefundProps) => {
  const { decision, type, transactionType = 'UNSUBSCRIBE', isBillingDay1stEnabled } = props

  let eventName = constants.analyticsEvents.unsubscribe

  if (transactionType !== 'UNSUBSCRIBE') {
    eventName = `${transactionType} choose option`
  }

  const typeCancel = decision === 'REFUND' ? 'refund' : 'keep'

  mixpanel.track(eventName, {
    'type time': getRefundTimeTypes(isBillingDay1stEnabled)[type],
    'type cancel': typeCancel,
    'type transaction': transactionType,
  })

  actions.models.ui.showRequestLoader()

  try {
    await actions.models.subscription.refund({
      transactionType,
      decision,
    })
  }
  catch (error) {
    console.error(error)
  }
  finally {
    actions.models.ui.hideRequestLoader()
  }
}


export default processVindiciaRefund
